(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-details.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-details.js');

'use strict';

const {
  MapSingle,
  PeppText,
  Distribution
} = svs.lyckoplatsen.components.shared_result.react.components;
const ResultDetails = _ref => {
  let {
    wagers = null,
    result
  } = _ref;
  return React.createElement("div", {
    className: "lp-result-details"
  }, React.createElement(MapSingle, {
    wagers: wagers,
    result: result
  }), React.createElement("div", {
    className: "details-wrapper"
  }, React.createElement(PeppText, {
    result: result
  }), React.createElement(Distribution, {
    result: result
  })));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ResultDetails
});

 })(window);